// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M0.978516 13.1206L10.878 23.0201L20.9999 12.9145L21 2.99805L11.1002 3.01525L0.978516 13.1206ZM14.9961 9.00382V7H16.9999L17.0001 9.00399L14.9961 9.00382Z"}}]};

const TagFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tag-filled',
    ref,
    icon: element,
  },
));

TagFilledIcon.displayName = 'TagFilledIcon';

export default TagFilledIcon;
